import { useState, useEffect, useContext } from "react";
import styles from "./style.module.scss"
import { api } from "../../../services/api";
import { Box } from "@mui/system";
import MultiSelectFilter from "../../multiSelectFilter";
import CloseIcon from "@mui/icons-material/Close";
import { GlobalAlertContext } from "../../../contexts/GlobalAlertContext";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import CardSys from "../../cardSys";
import { Grid } from "@mui/material";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ModalSys from "../../modal";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button } from "@mui/material";
import { IconButton, Toolbar, Tooltip } from "@mui/material";
import Divider from "@mui/material/Divider";
import GerarXlsx from "./hook/gerarXlsx";
import DateRangePickerValue from "../../dateRage";
import ValueRange from "../../valueRange";
import ButtonGroup from "../../buttonGroup";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { CSVLink, CSVDownload } from "react-csv";
import PrintIcon from "@mui/icons-material/Print";
import React from "react";
import { useNavigate } from "react-router-dom";

const columns = [
  {
    field: "CNPJ_label",
    headerName: "CNPJ/CPF Cliente/Devedor",
    width: 175,
    headerAlign: "center",
    align: "center"
  },
  {
    field: "devedor",
    headerName: "Cliente/Devedor",
    width: 470,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "contrato",
    headerName: "Contrato",
    width: 95,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "id_estagio",
    headerName: "Estágio",
    width: 110,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "data_entrada",
    headerName: "Entrada",
    width: 125,
    headerAlign: "center",
    align: "center",
    valueFormatter: ({ value }) =>
      value ? new Date(value).toLocaleDateString("pt-Br") : "",
  },
  {
    field: "titulo",
    headerName: "Título",
    width: 120,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "vencimento",
    headerName: "Vencimento",
    width: 125,
    headerAlign: "center",
    align: "center",
    valueFormatter: ({ value }) =>
      value ? new Date(value).toLocaleDateString("pt-Br") : "",
  },
  {
    field: "valor_original",
    headerName: "Valor Original",
    width: 150,
    headerAlign: "center",
    align: "center",
    valueFormatter: ({ value }) =>
      "R$ " + parseFloat(value).toLocaleString("pt-Br"),
  },
  {
    field: "saldo",
    headerName: "Saldo",
    width: 150,
    headerAlign: "center",
    align: "center",
    valueFormatter: ({ value }) =>
      "R$ " + parseFloat(value).toLocaleString("pt-Br"),
  },
  {
    field: "data_acordo",
    headerName: "Acordo",
    width: 125,
    headerAlign: "center",
    align: "center",
    valueFormatter: ({ value }) =>
      value ? new Date(value).toLocaleDateString("pt-Br") : "",
  },
  {
    field: "id_acordo",
    headerName: "ID do acordo",
    width: 100,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "data_finalizacao",
    headerName: "Finalização",
    headerAlign: "center",
    width: 125,
    align: "center",
    valueFormatter: ({ value }) =>
      value ? new Date(value).toLocaleDateString("pt-Br") : "",
  },
];

export default function TableDashboard({
  children,
  data,
  enterpriseSelected,
  analytic,
  ...props
}) {
  const { user } = useContext(AuthContext);
  const { gerarXlsx } = GerarXlsx();
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const [modal, setModal] = useState(false);
  const [groupsSelected, setGroupsSelected] = useState([]);
  const [optionsSelect, setOptionsSelect] = useState([]);
  const [completo, setCompleto] = useState([]);
  const [analytics, setAnalytics] = useState({});
  const [filter, setFilter] = useState({});
  const [dateStartfinalizacao, setDateStartfinalizacao] = useState("");
  const [dateEndfinalizacao, setDateEndfinalizacao] = useState("");
  const [dateStartacordo, setDateStartacordo] = useState("");
  const [dateEndacordo, setDateEndacordo] = useState("");
  const [dateStartentrada, setDateStartentrada] = useState("");
  const [dateEndentrada, setDateEndentrada] = useState("");
  const [dateStartvencimento, setDateStartvencimento] = useState("");
  const [dateEndvencimento, setDateEndvencimento] = useState("");
  const [valorMarks, setValorMarks] = useState([0, 0]);
  const [saldoMarks, setSaldoMarks] = useState([0, 0]);
  const [defaultValue, setdefaultValue] = useState({});
  const [defaultSaldo, setdefaultSaldo] = useState({});
  const [defaultFilter, setdefaultFilter] = useState({});
  const link = `/previewPdfAnalitics`;
  const total = data[0];
  data = data.filter((el) => el.name != "TOTAL");
  const enterprise = JSON.parse(localStorage.getItem("PreviewPDFClient"));

  useEffect(() => {
    if (analytic) {
      setCompleto(analytic);
    }
  }, [analytic]);

  useEffect(() => {
    if (completo) {
      initialize();
      filterAnalytics(groupsSelected);
      localStorage.setItem(
        "PreviewPDFenterprise",
        JSON.stringify(enterpriseSelected)
      );
    }
  }, [completo]);

  const filterArr = (value, position, type) => {
    if (value[0]?.id) {
      if (value[0]["id"] == "FINALIZADOS *") {
        value[0] = { id: "Finalizado" };
      } else if (value[0]["id"] == "TOTAL EM ABERTO") {
        value[0] = { id: "Em Aberto" };
      } else if (value[0]["id"] == "ACORDOS EM ANDAMENTO") {
        value[0] = { id: "Em Acordo" };
      } else if (value[0]["id"] == "BAIXA - PGTO DIRETO") {
        value[0] = { id: "Finalizado" };
      } else if (value[0]["id"] == "BAIXA - PDD") {
        value[0] = { id: "Finalizado" };
      } else if (value[0]["id"] == "BAIXA - AJUIZAMENTO") {
        value[0] = { id: "Finalizado" };
      } else if (value[0]["id"] == "BAIXA - RECUPERAÇÃO JUDICIAL") {
        value[0] = { id: "Finalizado" };
      } else {
        value[0] = { id: "Finalizado" };
      }
    }
    if (value && type == "MultiSelect") {
      setFilter((obj) => {
        obj[position] = value.map((v) => v.id);
        return { ...obj };
      });
    } else if ((value && type == "DateStart") || (value && type == "DateEnd")) {
      setFilter((obj) => {
        if (!obj[position]) {
          obj[position] = [];
        }
        if (type == "DateStart") {
          obj[position][type] = [value];
        } else if (type == "DateEnd") {
          obj[position][type] = [value];
        }
        return { ...obj };
      });
    } else if (value && type == "ValueRange") {
      setFilter((obj) => {
        obj[position] = value.map((v) => v);
        return { ...obj };
      });
    }
    localStorage.setItem("PreviewPDFFilter", JSON.stringify(filter));
    filterAnalytics(filter);
  };

  const filterAnalytics = async (result) => {
    if (Object.keys(defaultFilter).length != 0) {
      setdefaultFilter({});
    }

    Object.keys(result).forEach((element) => {
      if (Object.keys(result[element]).length == 0) {
        delete result[element];
      }
    });

    completo.forEach((element, index) => { element.id = index; });
    let thirdArray = completo;

    Object.keys(result).forEach((key) => {
      if (result[key]) {
        if (
          key == "devedor" ||
          key == "contrato" ||
          key == "CNPJ" ||
          key == "titulo" ||
          key == "id_estagio"
        ) {
          thirdArray = thirdArray.filter((r) => result[key].includes(r[key]));
        } else if (
          key == "data_entrada" ||
          key == "data_acordo" ||
          key == "vencimento" ||
          key == "data_finalizacao"
        ) {
          if (result[key]["DateStart"] && result[key]["DateEnd"]) {
            thirdArray = thirdArray.filter(
              (r) =>
                Date.parse(result[key]["DateStart"]) <= Date.parse(r[key]) &&
                Date.parse(result[key]["DateEnd"]) >= Date.parse(r[key])
            );
          } else if (result[key]["DateStart"] && !result[key]["DateEnd"]) {
            thirdArray = thirdArray.filter(
              (r) => Date.parse(result[key]["DateStart"]) <= Date.parse(r[key])
            );
          } else if (!result[key]["DateStart"] && result[key]["DateEnd"]) {
            thirdArray = thirdArray.filter(
              (r) => Date.parse(result[key]["DateEnd"]) >= Date.parse(r[key])
            );
          }
        } else {
          thirdArray = thirdArray.filter(
            (r) => result[key][0] <= r[key] && result[key][1] >= r[key]
          );
        }
      }
    });

    thirdArray.forEach((element, index) => {
      element.CNPJ_label = element.CNPJ.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5"
      );
    });

    //gera tabela
    setAnalytics(thirdArray);
  };

  const initialize = async () => {
    //a partir daqui somente da primeira vez
    //gera listas devedor
    var listSelect = [];
    listSelect["devedor"] = [];
    listSelect["contrato"] = [];
    listSelect["CNPJ"] = [];
    listSelect["titulo"] = [];
    listSelect["id_estagio"] = [];

    var optionList = [];
    optionList["devedor"] = [];
    optionList["contrato"] = [];
    optionList["CNPJ"] = [];
    optionList["titulo"] = [];
    optionList["id_estagio"] = [];
    //Select distinc by key and push to List Array
    Object.keys(optionList).forEach((key) => {
      optionList[key] = [...new Set(completo.map((item) => item[key]))];
      optionList[key].map((row, index) => {
        listSelect[key].push({ label: row, id: row });
      });
    });

    const maxValue = Math.max(...completo.map((o) => o.valor_original));

    // const maxValue = completo.reduce(function (prev, current) {
    //   return (prev.valor_original > current.valor_original) ? prev : current
    // }) //returns object

    const minValue = Math.min(...completo.map((o) => o.valor_original));

    setdefaultValue({
      minValue: Math.round(minValue),
      maxValue: Math.round(maxValue),
    });

    setValorMarks([minValue, maxValue]);

    const maxSaldo = Math.max(...completo.map((o) => o.saldo));
    const minSaldo = Math.min(...completo.map((o) => o.saldo));

    setdefaultSaldo({
      minValue: Math.round(minSaldo),
      maxValue: Math.round(maxSaldo),
    });

    setSaldoMarks([minSaldo, maxSaldo]);

    // setDateStartfinalizacao(

      
    //     Math.min(
    //       ...completo.map((element) => {
    //         if (element.data_finalizacao !== null) {
    //           return new Date(element.data_finalizacao )
    //         }
    //       })
    //     )
    // );
    // setDateEndfinalizacao(
      
    //     Math.max(
    //       ...completo.map((element) => {
    //         if (element.data_finalizacao !== null) {
    //           return new Date(element.data_finalizacao )
    //         }
    //       })
    //   )
    // );
    // setDateStartacordo(
    //   new Date(
    //     Math.min(
    //       ...completo.map((element) => {
    //         return element.data_acordo ? new Date(element.data_acordo) : '';
    //       })
    //     )
    //   )
    // );
    // setDateEndacordo(
    //   // new Date(
       
    //   // )
    //   Math.max(
    //     ...completo.map((element) => {
    //       return element.data_acordo ? new Date(element.data_acordo) : element.data_acordo;
    //     })
    //   ) ?  new Date(Math.max(
    //     ...completo.map((element) => {
    //       return element.data_acordo ? new Date(element.data_acordo) : element.data_acordo;
    //     })
    //   ) ) : new Date()
    // );
    // setDateStartentrada(
    //   new Date(
    //     Math.min(
    //       ...completo.map((element) => {
    //         return new Date(element.data_entrada);
    //       })
    //     )
    //   )
    // );
    // setDateEndentrada(
    //   new Date(
    //     Math.max(
    //       ...completo.map((element) => {
    //         return new Date(element.data_entrada);
    //       })
    //     )
    //   )
    // );
    // setDateStartvencimento(
    //   new Date(
    //     Math.min(
    //       ...completo.map((element) => {
    //         return new Date(element.vencimento);
    //       })
    //     )
    //   )
    // );
    // setDateEndvencimento(
    //   new Date(
    //     Math.max(
    //       ...completo.map((element) => {
    //         return new Date(element.vencimento);
    //       })
    //     )
    //   )
    // );
    //dates
    setOptionsSelect(listSelect);
  };

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          background: "transparent",
          boxShadow: "none",
          overflow: "hidden",
        }}
      >
        <Grid sx={{borderTop:"3px solid ",borderColor:"#E0EAFF",marginBottom:"24px"}}>
                            </Grid>
        <Table sx={{ Width: 20 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ paddingInline: "2px" }}></TableCell>
              <TableCell
                align="right"
                sx={{
                  width: "fit-content",
                  color: "#2c4992",
                  fontWeight: "bold",
                  fontSize: "0.850rem",
                  paddingInline: "2px",
                }}
              >
                Qtd
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  width: "fit-content",
                  color: "#2c4992",
                  fontWeight: "bold",
                  fontSize: "0.850rem",
                  paddingInline: "2px",
                }}
              >
                Valor
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  width: "fit-content",
                  color: "#2c4992",
                  fontWeight: "bold",
                  fontSize: "0.850rem",
                  paddingInline: "2px",
                }}
              >
                %
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((e, index) => {
              const porcentNumber = e.pct;
              const porcentClena = parseFloat(porcentNumber);
              const pct = porcentClena.toFixed(1).replaceAll(".", ",");
              return (
                <TableRow
                  key={e.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    align="right"
                    component="th"
                    scope="row"
                    sx={{ fontSize: "0.675rem", paddingInline: "2px" }}
                  >
                    <Button
                      sx={{ fontSize: "0.675rem" ,padding:0}}
                      onClick={() => {
                        filterArr(
                          [{ id: e.name, label: e.name }],
                          "id_estagio",
                          "MultiSelect"
                        );
                        setdefaultFilter(e.name);
                        setModal(true);
                      }}
                      variant="plain"
                    >
                      {e.name}
                    </Button>
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      width: "fit-content",
                      fontSize: "0.675rem",
                      paddingInline: "2px",
                    }}
                  >
                    {e.qtd}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      width: "fit-content",
                      fontSize: "0.675rem",
                      paddingInline: "2px",
                    }}
                  >
                    {e.val}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      width: "fit-content",
                      fontSize: "0.675rem",
                      paddingInline: "2px",
                    }}
                  >
                    {pct}
                  </TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell
                align="right"
                sx={{
                  width: "fit-content",
                  fontWeight: "bold",
                  paddingInline: "2px",
                  fontSize: "0.675rem",
                  borderTop: "2px solid black",
                }}
              >
                TOTAL
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  width: "fit-content",
                  fontWeight: "bold",
                  paddingInline: "2px",
                  fontSize: "0.675rem",
                  borderTop: "2px solid black",
                }}
              ></TableCell>
              <TableCell
                align="center"
                sx={{
                  width: "fit-content",
                  fontWeight: "bold",
                  paddingInline: "2px",
                  fontSize: "0.675rem",
                  borderTop: "2px solid black",
                }}
              >
                R$ {total.val}
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  width: "fit-content",
                  fontWeight: "bold",
                  paddingInline: "2px",
                  fontSize: "0.675rem",
                  borderTop: "2px solid black",
                }}
              ></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <ModalSys
        open={modal}
        handleClose={() => {
          setModal(false);
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <CardSys sx={{ width: "99vw" }}>
            <Box
              sx={{
                display: "flex",
                height: "0",
                flexDirection: "row-reverse",
              }}
            >
              <IconButton
                sx={{ m: 0, p: 0, zIndex: 10000 }}
                onClick={() => {setModal(false);setFilter([])}}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            <Toolbar
              sx={{
                width: "107vw",
                marginLeft: "1vw",
                border: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Grid container spacing={2} columns={22} gap={0.1}>
                <Grid item xs={4}>
                  <MultiSelectFilter
                    title={"Cliente/Devedor"}
                    options={optionsSelect.devedor ? optionsSelect.devedor : []}
                    handleSelected={(value) => {
                      filterArr(value, "devedor", "MultiSelect");
                      setGroupsSelected(value);
                    }}
                    border={"#00A7E1"}
                    focused
                  ></MultiSelectFilter>
                </Grid>
                <Grid item xs={4}>
                  <MultiSelectFilter
                    title={"Contrato"}
                    options={
                      optionsSelect.contrato ? optionsSelect.contrato : []
                    }
                    handleSelected={(value) => {
                      filterArr(value, "contrato", "MultiSelect");
                      setGroupsSelected(value);
                    }}
                    border={"#00A7E1"}
                  ></MultiSelectFilter>
                </Grid>
                <Grid item xs={3.5}>
                  <DateRangePickerValue
                    title={"Data de entrada"}
                    handleStart={(value) => {
                      filterArr(value, "data_entrada", "DateStart");
                      setDateStartentrada(value);
                    }}
                    handleEnd={(value) => {
                      filterArr(value, "data_entrada", "DateEnd");
                      setDateEndentrada(value);
                    }}
                    valueStart={dateStartentrada}
                    valueEnd={dateEndentrada}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#31b3e4",
                        },
                      },
                      ".css-i4bv87-MuiSvgIcon-root":{
                        color: "#2C4992"
                      },
                      ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input":{
                        fontSize: "0.9em !important;"
                      } 
                    }}
                  ></DateRangePickerValue>
                </Grid>
                <Grid item xs={4}>
                  <MultiSelectFilter
                    title={"Título"}
                    options={optionsSelect.titulo ? optionsSelect.titulo : []}
                    handleSelected={(value) => {
                      filterArr(value, "titulo", "MultiSelect");
                      setGroupsSelected(value);
                    }}
                    border={"#2C4992"}
                  ></MultiSelectFilter>
                </Grid>
                <Grid item xs={3.5}>
                  <DateRangePickerValue
                    title={"Data do Acordo"}
                    handleStart={(value) => {
                      filterArr(value, "data_acordo", "DateStart");
                      setDateStartacordo(value);
                    }}
                    handleEnd={(value) => {
                      filterArr(value, "data_acordo", "DateEnd");
                      setDateEndacordo(value);
                    }}
                    valueStart={dateStartacordo}
                    valueEnd={dateEndacordo}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#E2746F",
                        },
                      },
                      ".css-i4bv87-MuiSvgIcon-root":{
                        color: "#2C4992"
                      },
                      ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input":{
                        fontSize: "0.9em !important;"
                      } 
                    }}
                  ></DateRangePickerValue>
                </Grid>
                <Grid item xs={4}>
                  <MultiSelectFilter
                    title={"CNPJ/CPF - Cliente/Devedor"}
                    options={optionsSelect.CNPJ ? optionsSelect.CNPJ : []}
                    handleSelected={(value) => {
                      filterArr(value, "CNPJ", "MultiSelect");
                      setGroupsSelected(value);
                    }}
                    border={"#00A7E1"}
                  ></MultiSelectFilter>
                </Grid>
                <Grid item xs={4}>
                  <ButtonGroup
                    title={"Estágio"}
                    defaultFiltered={defaultFilter ? defaultFilter : {}}
                    options={
                      optionsSelect.id_estagio ? optionsSelect.id_estagio : []
                    }
                    handleSelected={(value) => {
                      filterArr(value, "id_estagio", "MultiSelect");
                    }}
                  />
                </Grid>
                <Grid item xs={3.5}>
                  <DateRangePickerValue
                    title={"Vencimento"}
                    handleStart={(value) => {
                      filterArr(value, "vencimento", "DateStart");
                      setDateStartvencimento(value);
                    }}
                    handleEnd={(value) => {
                      filterArr(value, "vencimento", "DateEnd");
                      setDateEndvencimento(value);
                    }}
                    valueStart={dateStartvencimento}
                    valueEnd={dateEndvencimento}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#31b3e4",
                        },
                      },
                      ".css-i4bv87-MuiSvgIcon-root":{
                        color: "#2C4992"
                      },
                      ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input":{
                        fontSize: "0.9em !important;"
                      } 
                    }}
                  ></DateRangePickerValue>
                </Grid>
                <Grid item xs={2} sx={{ margin: "0" }}>
                  <ValueRange
                    title={"V. Original"}
                    onChange={(event, newValue) => {
                      filterArr(newValue, "valor_original", "ValueRange");
                      setValorMarks(newValue);
                    }}
                    defaultValue={defaultValue}
                    marks={valorMarks}
                  />
                </Grid>
                <Grid item xs={2} sx={{ margin: "0" }}>
                  <ValueRange
                    title={"Saldo"}
                    onChange={(event, newValue) => {
                      filterArr(newValue, "saldo", "ValueRange");
                      setSaldoMarks(newValue);
                    }}
                    defaultValue={defaultSaldo}
                    marks={saldoMarks}
                  />
                </Grid>
                <Grid item xs={3.5}>
                  <DateRangePickerValue
                    title={"Data de Finalização"}
                    handleStart={(value) => {
                      filterArr(value, "data_finalizacao", "DateStart");
                      setDateStartfinalizacao(value);
                    }}
                    handleEnd={(value) => {
                      filterArr(value, "data_finalizacao", "DateEnd");
                      setDateEndfinalizacao(value);
                    }}
                    valueStart={dateStartfinalizacao}
                    valueEnd={dateEndfinalizacao}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "#E2746F",
                        },
                      },
                      ".css-i4bv87-MuiSvgIcon-root":{
                        color: "#2C4992"
                      },
                      ".css-nxo287-MuiInputBase-input-MuiOutlinedInput-input":{
                        fontSize: "0.9em !important;"
                      } 
                    }}
                  ></DateRangePickerValue>
                </Grid>
              </Grid>
            </Toolbar>
            <Divider
              sx={{
                marginBottom: 1,
                marginTop: 5,
                marginLeft: -2,
                marginRight: -2,
                color: "#2B3A8B",
              }}
            />
            <Box
              m={3}
              display="flex"
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <Tooltip title="Imprimir">
                <a
                  href={link}
                  style={{
                    color: "white",

                    backgroundColor: "#0032A0",
                    width: "40px",
                    height: "40px",
                    padding: "6px 8px",
                    borderRadius: "4px",

                    display: "flex",
                    alignItems: "center",

                    justifyContent: "center",
                    marginRight: "20px",
                  }}
                  target="_blank"
                >
                  <PrintIcon sx={{ color: "white" }} />
                </a>
              </Tooltip>

              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <Grid>
                      <Tooltip title="Exportar Excel/CSV">
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ width: "fit-content", minWidth: "0" }}
                          style={{
                            backgroundColor: "#0032A0",
                            width: "40px",

                            height: "40px",
                          }}
                          {...bindTrigger(popupState)}
                        >
                          <FileDownloadIcon
                            color="disabled"
                            size="small"
                            sx={{ color: "white" }}
                          />
                        </Button>
                      </Tooltip>
                    </Grid>

                    <Menu {...bindMenu(popupState)}>
                      <MenuItem
                        onClick={() => {
                          console.log()
                          gerarXlsx(analytics, filter, enterprise);
                        }}
                      >
                        Excel(.xlsx)
                      </MenuItem>

                      <MenuItem>
                        <CSVLink
                          data={analytics}
                          filename={"analytcs.csv"}
                          className="csvlink"
                          target="_blank"
                        >
                          CSV
                        </CSVLink>
                      </MenuItem>
                    </Menu>
                  </React.Fragment>
                )}
              </PopupState>
            </Box>

            <div style={{ height: 400, width: "100%" }}>
              <DataGrid
                rows={analytics}
                columns={columns}
                getRowId={(row) => row.id}
                rowHeight={40}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 5 },
                  },
                }}
                sx={{
                  "& .MuiDataGrid-cell": {
                    border: "solid",
                    borderWidth:" 0.3px",
                    borderColor: "#31b3e4 !important",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    border: "solid",
                    borderWidth:" 0.3px",
                    borderColor: "#31b3e4 !important",
                  },
                }}
                pageSizeOptions={[5, 10]}
                rowsPerPageOptions={[]}
              />
            </div>
          </CardSys>
        </Box>
      </ModalSys>
    </>
  );
}
